import { DriverLeadCreationV2 } from "../layout";
import PageLayout from "./PageLayout";

const DriverLeadCreationPageV2 = () => {
  return (
    <PageLayout
      sx={{
        width: { xs: "92%", sm: "90%", md: "85%", lg: "85%" },
        px: 0,
        py: 0,
        mt: 4,
      }}
    >
      <DriverLeadCreationV2 />
    </PageLayout>
  );
};

export default DriverLeadCreationPageV2;
